<template>
  <div class="row">
    <div class="col order-summary-toggle d-block d-none-md w-100">
      <button class="btn btn-block btn-show" @click="toggleOrderSummary">
        Show order summary
        <i class="fa fa-caret-down"></i>
      </button>

      <div :class="['container p0', shouldShowOrderSummary ? 'show' : '']">
        <div class="cart--side">
          <cart-review />
        </div>
      </div>
    </div>

    <ValidationObserver
      ref="formObserver"
      tag="form"
      class="col-lg-7 mb50-md mb20 pr30-lg"
      @submit.prevent="onSubmit"
    >
      <loader :loading="loading"></loader>
      <checkout-breadcrumbs />

      <section class="contact--block bt-lightgray mb30-md mb20">
        <div
          class="block-title d-sm-flex align-items-center bb-lightgray py20-md py10"
        >
          <h2 class="main-title tc-custom-red fs22 m0-sm mt0 mb10">Contact Information</h2>

          <div class="login ml-sm-auto">
            <p class="mb0">
              <template v-if="isAuthUser">
                Not you?
                <a href="/logout" class="main-link">
                  Logout
                </a>
              </template>
              <template v-else>
                Already have an account?
                <a href="/login" class="main-link">
                  Log-in
                </a>
              </template>
            </p>
          </div>
        </div>

        <div
          v-if="!isAuthUser"
          class="py10 px20-sm mb0 bb-lightgray contact--details"
        >
          <ValidationProvider
            rules="required"
            name="Full Name"
            tag="div"
            class="form-group"
            v-slot="{ errors }"
          >
            <input
              type="text"
              class="webform-control form-control"
              name="full_name"
              placeholder="Full Name*"
              v-model="fullName"
            />
            <span v-if="errors.length > 0" class="label--error text-danger">
              {{ errors[0] }}
            </span>
          </ValidationProvider>
          <ValidationProvider
            rules="required|email"
            name="Email"
            tag="div"
            class="form-group"
            v-slot="{ errors }"
          >
            <input
              type="text"
              class="webform-control form-control"
              name="email"
              placeholder="Email*"
              v-model="email"
            />
            <span v-if="errors.length > 0" class="label--error text-danger">
              {{ errors[0] }}
            </span>
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            name="Mobile/Phone number*"
            tag="div"
            class="form-group mb0"
            v-slot="{ errors }"
          >
            <input
              type="text"
              class="webform-control form-control"
              name="mobile_number"
              placeholder="Mobile/Phone number*"
              v-model="contactNumber"
            />
            <span v-if="errors.length > 0" class="label--error text-danger">
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </div>

        <div
          v-else
          class="form-group py10 px20 mb0 bb-lightgray contact--details"
        >
          <span class="mb10 fs14">Full Name</span>
          <p>{{ fullName }}</p>

          <span class="mb10 fs14">Email</span>
          <p>{{ email }}</p>

          <span class="mb10 fs14">Mobile/Phone number</span>
          <p class="mb0">{{ contactNumber || "N/A" }}</p>
        </div>

        <!-- <div
          v-if="!isAuthUser"
          class="form-check custom__checkbox mt20-md mt10"
        >
          <input
            id="subscription"
            class="form-check-input"
            type="checkbox"
            name="subscribe"
            v-model="subscribeToNewsLetter"
          />
          <label for="subscription" class="form-check-label">
            Keep me up to date on news and exclusive offers
          </label>
        </div> -->
      </section>

      <section class="delivery--block mb30-md mb20">
        <h2 class="main-title tc-custom-red fs22 m0 pb15 bb-lightgray">Delivery Method</h2>

        <ValidationProvider
          rules="required"
          name="Delivery Method"
          tag="div"
          class="form-group"
          v-slot="{ errors }"
        >
          <div class="custom-control custom__radio py15 bb-lightgray">
            <input
              type="radio"
              id="shipping"
              name="customRadio"
              class="custom-control-input"
              value="shipping"
              v-model="deliveryMethod"
              :disabled="shippingMethods.length <= 0"
            />
            <label
              class="custom-control-label d-flex align-items-center"
              for="shipping"
            >
              <i class="icon cart-shipping mr10"></i>
              Shipping &nbsp;<span v-if="shippingMethods.length <= 0">(Unavailable)</span>
            </label>
          </div>
          <div class="custom-control custom__radio py15 bb-lightgray">
            <input
              type="radio"
              id="pickup"
              name="customRadio"
              class="custom-control-input"
              value="pickup"
              v-model="deliveryMethod"
              :disabled="stores.length <= 0"
            />
            <label
              class="custom-control-label d-flex align-items-center"
              for="pickup"
            >
              <i class="icon cart-pickup mr10"></i>
              Pick-up &nbsp;<span v-if="stores.length <= 0">(Unavailable)</span>
            </label>
          </div>
          <span v-if="errors.length > 0" class="label--error text-danger">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
      </section>

      <section
        v-if="deliveryMethod === 'shipping'"
        class="delivery--block pb30-md pb20 bb-lightgray"
      >
        <h2 class="main-title tc-custom-red fs22">Delivery Address</h2>
        <div class="row">
          <ValidationProvider
            rules="required"
            name="First Name"
            tag="div"
            class="col-lg-6 col-sm-12"
            v-slot="{ errors }"
          >
            <div class="form-group mb20">
              <input
                type="text"
                name="shipping[first_name]"
                class="webform-control form-control"
                placeholder="First Name"
                v-model="shippingFirstName"
              />
              <span v-if="errors.length > 0" class="label--error text-danger">
                {{ errors[0] }}
              </span>
            </div>
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            name="Last Name"
            tag="div"
            class="col-lg-6 col-sm-12"
            v-slot="{ errors }"
          >
            <div class="form-group mb20">
              <input
                type="text"
                name="shipping[last_name]"
                class="webform-control form-control"
                placeholder="Last Name"
                v-model="shippingLastName"
              />
              <span v-if="errors.length > 0" class="label--error text-danger">
                {{ errors[0] }}
              </span>
            </div>
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            name="Contact Number"
            tag="div"
            class="col-lg-6 col-sm-12"
            v-slot="{ errors }"
          >
            <div class="form-group mb20">
              <input
                type="text"
                name="shipping[contact_number]"
                class="webform-control form-control"
                placeholder="Contact Number"
                v-model="shippingContactNumber"
              />
              <span v-if="errors.length > 0" class="label--error text-danger">
                {{ errors[0] }}
              </span>
            </div>
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            name="Unit"
            tag="div"
            class="col-lg-6 col-sm-12"
            v-slot="{ errors }"
          >
            <div class="form-group mb20">
              <input
                type="text"
                name="shipping[unit]"
                class="webform-control form-control"
                placeholder="Unit"
                v-model="shippingUnit"
              />
              <span v-if="errors.length > 0" class="label--error text-danger">
                {{ errors[0] }}
              </span>
            </div>
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            name="Barangay"
            tag="div"
            class="col-lg-6 col-sm-12"
            v-slot="{ errors }"
          >
            <div class="form-group mb20">
              <input
                type="text"
                name="shipping[barangay]"
                class="webform-control form-control"
                placeholder="Barangay"
                v-model="shippingBarangay"
              />
              <span v-if="errors.length > 0" class="label--error text-danger">
                {{ errors[0] }}
              </span>
            </div>
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            name="City"
            tag="div"
            class="col-lg-6 col-sm-12"
            v-slot="{ errors }"
          >
            <div class="form-group mb20">
              <input
                type="text"
                placeholder="City"
                name="shipping[city]"
                class="webform-control form-control"
                v-model="shippingCity"
              />
              <span v-if="errors.length > 0" class="label--error text-danger">
                {{ errors[0] }}
              </span>
            </div>
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            name="Province"
            tag="div"
            class="col-lg-6 col-sm-12"
            v-slot="{ errors }"
          >
            <div class="form-group mb20">
              <input
                type="text"
                placeholder="Province"
                name="shipping[province]"
                class="webform-control form-control"
                v-model="shippingProvince"
              />
              <span v-if="errors.length > 0" class="label--error text-danger">
                {{ errors[0] }}
              </span>
            </div>
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            name="Postal Code"
            tag="div"
            class="col-lg-6 col-sm-12"
            v-slot="{ errors }"
          >
            <div class="form-group mb20">
              <input
                type="text"
                class="webform-control form-control"
                name="shipping[postal_code]"
                placeholder="Postal Code*"
                v-model="shippingPostalCode"
              />
              <span v-if="errors.length > 0" class="label--error text-danger">
                {{ errors[0] }}
              </span>
            </div>
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            name="Country"
            tag="div"
            class="col-sm-12"
            v-slot="{ errors }"
          >
            <div class="form-group mb20">
              <div class="select--country">
                <label for="country">Country/Region</label>
                <select
                  id="country"
                  class="form-control"
                  name="shipping[country]"
                  autocomplete="off"
                  v-model="shippingCountry"
                >
                  <option selected value="PH">Philippines</option>
                </select>
              </div>
              <span v-if="errors.length > 0" class="label--error text-danger">
                {{ errors[0] }}
              </span>
            </div>
          </ValidationProvider>
          <div v-if="!isAuthUser" class="col-sm-12">
            <div class="form-check custom__checkbox">
              <input
                id="save-add"
                class="form-check-input"
                type="checkbox"
                v-model="shouldSaveInfo"
              />
              <label for="save-add" class="form-check-label">
                Save this information for the next time
              </label>
            </div>
          </div>
        </div>
      </section>

      <section
        v-else-if="deliveryMethod === 'pickup'"
        class="pickup--block pb30"
      >
        <h2 class="main-title tc-custom-red fs22 m0 pb20 bb-lightgray">Pick-up Location</h2>

        <ValidationProvider
          rules="required"
          name="Pick-up Location"
          tag="div"
          class="form-group"
          v-slot="{ errors }"
        >
          <div
            v-for="(store, index) in stores"
            :key="index"
            class="custom-control custom__radio px0 py15 bb-lightgray"
          >
            <input
              type="radio"
              :id="store.slug"
              name="store"
              class="custom-control-input"
              :value="store.id"
              v-model="pickupLocation"
            />
            <label
              class="custom-control-label d-flex flex-column"
              :for="store.slug"
            >
              <span>
                {{ store.title }}
              </span>
              <span class="location-add fs14">
                {{ store.address }}
              </span>
            </label>
          </div>
          <span v-if="errors.length > 0" class="label--error text-danger">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
      </section>

      <section
        class="action-btn d-flex align-items-center justify-content-between flex-sm-row flex-column-reverse mt30-md mt20"
      >
        <div>
          <router-link :to="{ name: 'cart' }" class="main-link">
            &#60; Return to Cart
          </router-link>
        </div>
        <div class="main-btn px0">
          <button type="submit">
            <template v-if="deliveryMethod === 'shipping'">
              Continue to shipping
            </template>
            <template v-else>
              Continue to payment
            </template>
          </button>
        </div>
      </section>
    </ValidationObserver>

    <div class="col-lg-5 cart--side pt10">
      <cart-review />
    </div>
  </div>
</template>

<script>
import CheckoutBreadcrumbs from "../components/checkout/CheckoutBreadcrumbs";
import CartReview from "../components/checkout/CartReview";
import Loader from "../components/Loader";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import shippingMethod from "../api/shippingMethod";
import storage from "../helpers/storage";
import store from "../api/store";
import { mapStateWithMutation } from "../helpers/vuexHelpers";

export default {
  props: {
    user: Object,
    shipping: Object
  },
  components: {
    CheckoutBreadcrumbs,
    CartReview,
    Loader,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      loading: false,
      shouldSaveInfo: false,
      shouldShowOrderSummary: false,
      shippingMethods: false,
      stores: []
    };
  },
  computed: {
    isAuthUser() {
      return this.$store.state.checkout.isAuthUser;
    },
    ...mapStateWithMutation("checkout", {
      fullName: {
        state: state => state.contact.fullName,
        mutation: "UPDATE_CONTACT_FULL_NAME"
      },
      email: {
        state: state => state.contact.email,
        mutation: "UPDATE_CONTACT_EMAIL"
      },
      contactNumber: {
        state: state => state.contact.contactNumber,
        mutation: "UPDATE_CONTACT_NUMBER"
      },
      deliveryMethod: {
        state: state => state.deliveryMethod,
        mutation: "UPDATE_DELIVERY_METHOD"
      },
      shippingFirstName: {
        state: state => state.shipping.firstName,
        mutation: "UPDATE_SHIPPING_FIRST_NAME"
      },
      shippingLastName: {
        state: state => state.shipping.lastName,
        mutation: "UPDATE_SHIPPING_LAST_NAME"
      },
      shippingContactNumber: {
        state: state => state.shipping.contactNumber,
        mutation: "UPDATE_SHIPPING_CONTACT_NUMBER"
      },
      shippingUnit: {
        state: state => state.shipping.unit,
        mutation: "UPDATE_SHIPPING_UNIT"
      },
      shippingBarangay: {
        state: state => state.shipping.barangay,
        mutation: "UPDATE_SHIPPING_BARANGAY"
      },
      shippingCity: {
        state: state => state.shipping.city,
        mutation: "UPDATE_SHIPPING_CITY"
      },
      shippingProvince: {
        state: state => state.shipping.province,
        mutation: "UPDATE_SHIPPING_PROVINCE"
      },
      shippingPostalCode: {
        state: state => state.shipping.postalCode,
        mutation: "UPDATE_SHIPPING_POSTAL_CODE"
      },
      shippingCountry: {
        state: state => state.shipping.country,
        mutation: "UPDATE_SHIPPING_COUNTRY"
      },
      pickupLocation: {
        state: state => state.pickupLocation,
        mutation: "UPDATE_PICKUP_LOCATION"
      },
      subscribeToNewsLetter: {
        state: state => state.subscribeToNewsLetter,
        mutation: "UPDATE_SUBSCRIBE_TO_NEWS_LETTER"
      }
    })
  },
  watch: {
    pickupLocation(newVal) {
      const { title = "", address = "" } = this.stores.find(
        store => store.id === newVal
      );

      return this.$store.commit(
        "checkout/UPDATE_PICKUP_LOCATION_ADDRESS",
        title + " - " + address
      );
    }
  },
  async created() {
    this.loading = true;
    this.$validator.localize("en", {
      custom: {
        "Delivery Method": {
          required: "Select a Delivery Method"
        }
      }
    });

    const {
      data: { stores }
    } = await store.all();

    this.stores = stores;

    const {
      data: { shipping_methods }
    } = await shippingMethod.all();

    this.shippingMethods = shipping_methods;

    this.loading = false;
  },
  methods: {
    async onSubmit(event) {
      const isValid = await this.$refs.formObserver.validate();

      if (!isValid) {
        return;
      }

      if (this.shouldSaveInfo) {
        storage.update("_contact", {
          fullName: this.fullName,
          email: this.email,
          contactNumber: this.contactNumber
        });

        storage.update("_shipping", {
          firstName: this.shippingFirstName,
          lastName: this.shippingLastName,
          contactNumber: this.shippingContactNumber,
          unit: this.shippingUnit,
          barangay: this.shippingBarangay,
          city: this.shippingCity,
          province: this.shippingProvince,
          postalCode: this.shippingPostalCode,
          country: this.shippingCountry
        });
      }

      this.$store.commit("checkout/UPDATE_STEP_COMPLETED", "information");

      switch (this.deliveryMethod) {
        case "shipping":
          return this.$router.push({ name: "shipping" });
        case "pickup":
          return this.$router.push({ name: "payment" });
        default:
          return;
      }
    },
    toggleOrderSummary() {
      this.shouldShowOrderSummary = !this.shouldShowOrderSummary;
    }
  }
};
</script>

<style></style>
